const ALLOWED_API_ORIGINS = [
  'http://localhost:3000',
  'https://api.inco.infin-software.fi',
  'https://inco-nis2-we-api.azurewebsites.net',
];

const normalizeBaseUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return '';
  }
  const trimmed = url.trim();
  if (!trimmed) {
    return '';
  }
  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
};

const DEFAULT_LOCAL_API = 'http://localhost:3000';
const DEFAULT_PROD_API = 'https://api.inco.infin-software.fi';

const isAllowedOrigin = (url) => {
  try {
    const parsed = new URL(url);
    return ALLOWED_API_ORIGINS.some(allowed => {
      const allowedParsed = new URL(allowed);
      return parsed.origin === allowedParsed.origin;
    });
  } catch {
    return false;
  }
};

const resolveBaseUrl = () => {
  const envUrl = normalizeBaseUrl(process.env.REACT_APP_API_URL);
  if (envUrl && isAllowedOrigin(envUrl)) {
    return envUrl;
  }

  if (typeof window !== 'undefined') {
    const runtimeUrl = normalizeBaseUrl(window.__NIS2_API_URL__);
    if (runtimeUrl && isAllowedOrigin(runtimeUrl)) {
      return runtimeUrl;
    }

    const host = window.location?.hostname || '';
    if (host.includes('azurestaticapps.net') || host.includes('nis2ware') || host.includes('guard365') || host.includes('infin-software.fi')) {
      return DEFAULT_PROD_API;
    }
  }

  return DEFAULT_LOCAL_API;
};

const rawBaseUrl = resolveBaseUrl();
export const API_BASE_URL = `${rawBaseUrl}/api/v1`;

export const apiUrl = (path = '') => {
  if (!path) {
    return API_BASE_URL;
  }
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

export const buildAuthHeaders = (headers = {}) => {
  const token = sessionStorage.getItem('token');
  const selectedTenantId = sessionStorage.getItem('selectedTenantId');

  const result = { ...headers };

  if (token && !result.Authorization) {
    result.Authorization = `Bearer ${token}`;
  }

  if (selectedTenantId && !result['x-tenant-id']) {
    result['x-tenant-id'] = selectedTenantId;
  }

  return result;
};
